<template>
    <div>
        <base-modal :isOpen="value" :title="title" @close="close" size="md">
            <template #body>

                <div v-for="t in data" :key="t.id" class="transaction-card bg-white shadow rounded p-4 mb-6">
                    <div class="grid grid-cols-2 gap-4">
                        <div>
                            <p><strong>{{ $tc('type',1) | capitalize}}: </strong> {{ $t(t.link_name) | capitalize  }}</p>
                            <p><strong>{{ $t('reference') | capitalize }}: </strong> {{ t.reference_id }}</p>
                            <p><strong>Total: </strong> {{ formatCurrency(t.total) }}</p>
                        </div>
                        <div>
                            <p><strong>{{  $t('assigned_by') | capitalize}}: </strong> {{ t.user_name }}</p>
                            <p><strong>{{  $t('comments') | capitalize}}: </strong> {{ t.comments }}</p>
                        </div>
                    </div>
                </div>
            </template>
            <template #footer>
                <div class="flex gap-4">
                    <vs-button color="danger" icon="close" type="flat" @click="close">
                        {{ $t('close') | upperCase }}
                    </vs-button>
                </div>
            </template>
        </base-modal>
    </div>

</template>

<script setup>
import { ref, watch } from 'vue'
import BaseModal from '@/views/app/components/BaseModal'
import { formatCurrency, renderDate } from '@/utils/helpers'
import { capitalize } from '../../../../../../utils/helpers'

const props = defineProps({
    value: { type: Boolean, default: false },
    title: { type: String, default: 'Title' },
    data: { type: Array, default: () => ([]) }
})

const emit = defineEmits(['submit', 'input'])



const close = () => {
    emit('input', false)
}

const submit = () => {

    emit('submit')
}

</script>

<style scoped>
.transaction-card {
    border: 1px solid #ddd;
    padding: 10px;
    margin-bottom: 15px;
    border-radius: 6px;
    background: #f9f9f9;
}
</style>
